import { render, staticRenderFns } from "./admin-table.vue?vue&type=template&id=ea47425a&"
import script from "./admin-table.vue?vue&type=script&lang=js&"
export * from "./admin-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports